import * as React from 'react';
import { Accordion, AccordionItem } from '@grandvisionhq/common';
import { UspGroupItem } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { DiscountDescriptionsContainer } from '../DiscountDescriptions/containers/DiscountDescriptionsContainer.js';
import { VoucherCodeFormContainer } from '../VoucherCodes/VoucherCodeForm/VoucherCodeFormContainer.js';
import { TotalsContainer } from '../Totals/containers/TotalsContainer.js';
import { NavigationContainer } from './components/navigation/NavigationContainer.js';

const Footer = ({ readOnly , summaryLabel , formTitleLabel , policyItems , unavailableLineItems  })=>/*#__PURE__*/ React.createElement("div", {
        className: "cart-footer"
    }, policyItems && /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container mobile-hidden"
    }, policyItems.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    )), !readOnly && /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__aside"
    }, /*#__PURE__*/ React.createElement(DiscountDescriptionsContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__main"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "cart-footer__heading",
        variant: "small"
    }, summaryLabel), !readOnly && /*#__PURE__*/ React.createElement(Accordion, {
        className: "cart-footer__acc"
    }, /*#__PURE__*/ React.createElement(AccordionItem, {
        id: "discount-code",
        className: "cart-footer__acc__item",
        label: formTitleLabel,
        headingLevel: "h4"
    }, /*#__PURE__*/ React.createElement(VoucherCodeFormContainer, {
        className: "cart-footer__acc__form",
        inputId: "discount-code"
    }))), /*#__PURE__*/ React.createElement(TotalsContainer, null)), !readOnly && /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__navigation"
    }, /*#__PURE__*/ React.createElement(NavigationContainer, {
        unavailableLineItems: unavailableLineItems
    })), policyItems && /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container desktop-hidden"
    }, policyItems.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    )))
;

export { Footer };
//# sourceMappingURL=Footer.js.map
